import mod from "-!./Banner.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Banner.js?vue&type=script&lang=js&external"